<div>
  <h2 mat-dialog-title class="bulk-selection__title">{{ 'COM.DIALOGS.BULK.BULK_SELECTION' | translate }}</h2>
  <button class="bulk-selection__close-btn" mat-icon-button mat-dialog-close data-cy="bulk-selection-close" aria-label="Dialog close">
    <mat-icon class="circle-icon">close</mat-icon>
  </button>
</div>

<mat-dialog-content class="mat-typography py-5">
  <div class="bulk-selection">
    <form [formGroup]="offerForm" class="offer-form">
      <mat-form-field
        appearance="outline"
        subscriptSizing="dynamic"
        class="offer-form__value"
        [ngClass]="{ 'mat-form-field-invalid': invalidFormName === 'bulkValue' || invalidFormName === 'bulkValueOrOptOut' }"
      >
        <input
          *ngIf="selectedTabOption.value === TabOptionsEnum.Baselines"
          (wheel)="$event.preventDefault()"
          formControlName="offerValue"
          type="number"
          class="mt-1 input-number-no-arrows"
          matInput
          placeholder="{{ 'COM.DIALOGS.BULK.ENTER_VALUE' | translate }}"
          data-cy="bulk-selection-baseline-value-input"
        />

        <input
          *ngIf="selectedTabOption.value !== TabOptionsEnum.Baselines"
          (wheel)="$event.preventDefault()"
          formControlName="offerValue"
          type="number"
          validateNumber
          [min]="minBulkValue"
          [max]="maxBulkValue"
          [allowZero]="allowZeroValue"
          [errorStateMatcher]="customErrorStateMatcher"
          class="mt-1 input-number-no-arrows"
          matInput
          placeholder="{{ 'COM.DIALOGS.BULK.ENTER_VALUE' | translate }}"
          data-cy="bulk-selection-non-baselines-value-input"
        />

        <mat-error *ngIf="offerError">{{ offerError }}</mat-error>
      </mat-form-field>
      <ng-container *ngIf="selectedTabOption.optOut" class="bulk-selection__opt-out">
        <span>{{ 'COM.LABELS.OR' | translate }}</span>
        <mat-checkbox
          [class.bulk-optout]="!isExternalUser"
          formControlName="optOut"
          color="primary"
          data-cy="bulk-selection-optout"
          [ngClass]="{ 'mat-checkbox-invalid': invalidFormName === 'bulkValueOrOptOut' }"
        >
          {{ 'COM.CHECKBOX.OPT_OUT' | translate }}
        </mat-checkbox>
      </ng-container>
      <mat-checkbox
        *ngIf="!isExternalUser && showOfferLock"
        formControlName="offerLock"
        color="primary"
        data-cy="bulk-selection-offer-lock"
        [ngClass]="{ 'mat-checkbox-invalid': invalidFormName === 'bulkValueOrOptOut' }"
      >
        {{ 'COM.CHECKBOX.OFFER_LOCK' | translate }}
      </mat-checkbox>
    </form>

    <form [formGroup]="customRangeForm" class="custom-range-form">
      <div id="bulk-operation" class="bulk-selection__operation mat-button-container--toggle mat-button-container--toggle-border">
        <mat-button-toggle-group
          style="align-self: start"
          name="bulkOperationBehavior"
          formControlName="bulkOperationBehavior"
          (change)="onBulkOperationBehaviorChange($event)"
          aria-label="Type of bulk operation"
        >
          <mat-button-toggle data-cy="bulk-selection-baseline-inclusive" value="inclusive">{{
            'COM.DIALOGS.BULK.OPERATION.INCLUSIVE' | translate
          }}</mat-button-toggle>
          <mat-button-toggle data-cy="bulk-selection-baseline-specific" value="specific">{{
            'COM.DIALOGS.BULK.OPERATION.SPECIFIC' | translate
          }}</mat-button-toggle>
        </mat-button-toggle-group>

        <p>{{ bulkEditOperationDescription }}</p>
      </div>
      <!-- <p>Intervals that have not been specified or covered by the inputted intervals will retain their original values.</p> -->

      <div class="bulk-selection__container">
        <!-- ----- -->
        <!-- START -->
        <!-- ----- -->
        <div id="bulk-start-datetime" class="bulk-selection__container--section">
          <h3 *ngIf="selectedTabOption.value === TabOptionsEnum.Schedule" class="content-title">{{ 'COM.LABELS.START_DAY' | translate }}:</h3>
          <h3 *ngIf="selectedTabOption.value !== TabOptionsEnum.Schedule" class="content-title">{{ 'COM.LABELS.START_DATE' | translate }}:</h3>
          <!-- ---------- -->
          <!-- START DATE -->
          <!-- ---------- -->
          <lib-ngx-date-range-picker
            *ngIf="selectedTabOption.value !== TabOptionsEnum.Schedule"
            ngDefaultControl
            [error]="startDateError"
            [datePickerType]="selectedType"
            [title]="'COM.LABELS.FROM' | translate"
            [border]="true"
            [selectedDate]="startDate"
            [minDate]="minStartDate"
            [maxDate]="maxStartDate"
            [disabled]="false"
            [invalid]="false"
            [isHint]="true"
            [hint]="datePickerHint()"
            [format]="datePickerFormat()"
            class="export-date"
            data-cy="bulk-selection-start-datepicker"
          >
          </lib-ngx-date-range-picker>

          <mat-form-field *ngIf="selectedTabOption.value === TabOptionsEnum.Schedule" appearance="outline" subscriptSizing="dynamic" class="w-20">
            <mat-select formControlName="startDaySelectedPeriod">
              <mat-option [value]="option.value" *ngFor="let option of startDayPeriodOptions">
                {{ option.label }}
              </mat-option>
            </mat-select>
            <mat-error>{{ startPeriodError }}</mat-error>
          </mat-form-field>

          <h3 class="content-title mt-3">{{ 'COM.LABELS.START_TIME' | translate }}:</h3>

          <!-- add bulk selection start hour/minute -->
          <dr-customer-offers-ui-hour-minute-picker
            [hourFormControl]="startHour12"
            [minuteFormControl]="startMinute"
            [periodFormControl]="startPeriod"
            [minuteFrequency]="minuteFrequency"
          >
          </dr-customer-offers-ui-hour-minute-picker>
        </div>

        <div class="bulk-selection__container--border"></div>

        <div id="bulk-end-datetime" class="bulk-selection__container--section">
          <h3 *ngIf="selectedTabOption.value === TabOptionsEnum.Schedule" class="content-title">{{ 'COM.LABELS.END_DAY' | translate }}:</h3>
          <h3 *ngIf="selectedTabOption.value !== TabOptionsEnum.Schedule" class="content-title">{{ 'COM.LABELS.END_DATE' | translate }}:</h3>

          <div>
            <!-- ---------- -->
            <!-- END DATE -->
            <!-- ---------- -->
            <lib-ngx-date-range-picker
              *ngIf="selectedTabOption.value !== TabOptionsEnum.Schedule"
              ngDefaultControl
              [error]="endDateError"
              [datePickerType]="selectedType"
              [title]="'COM.LABELS.TO' | translate"
              [border]="true"
              [selectedDate]="endDate"
              [minDate]="minEndDate"
              [maxDate]="maxEndDate"
              [disabled]="false"
              [invalid]="false"
              [isHint]="true"
              [hint]="datePickerHint()"
              [format]="datePickerFormat()"
              class="export-date"
              data-cy="bulk-selection-end-datepicker"
            >
            </lib-ngx-date-range-picker>

            <mat-form-field *ngIf="selectedTabOption.value === TabOptionsEnum.Schedule" appearance="outline" subscriptSizing="dynamic" class="w-20">
              <mat-select formControlName="endDaySelectedPeriod">
                <mat-option [value]="option.value" *ngFor="let option of endDayPeriodOptions">
                  {{ option.label }}
                </mat-option>
              </mat-select>
              <mat-error>{{ endPeriodError }}</mat-error>
            </mat-form-field>
          </div>

          <h3 class="content-title mt-3">{{ 'COM.LABELS.END_TIME' | translate }}:</h3>

          <dr-customer-offers-ui-hour-minute-picker
            [hourFormControl]="endHour12"
            [minuteFormControl]="endMinute"
            [periodFormControl]="endPeriod"
            [minuteFrequency]="minuteFrequency"
          >
          </dr-customer-offers-ui-hour-minute-picker>
        </div>
      </div>
    </form>
    <div class="bulk-selection__outcome">
      <h3>{{ bulkOperationOutcome }}</h3>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="pb-4 pe-5 ps-5 justify-right">
  <button mat-flat-button (click)="apply()" color="primary" [disabled]="isApplyDisabled" class="bulk-selection_apply-btn">
    {{ 'COM.BUTTONS.APPLY' | translate }}
  </button>
</mat-dialog-actions>
